"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumPolicyFilter = void 0;
var EnumPolicyFilter;
(function (EnumPolicyFilter) {
    EnumPolicyFilter[EnumPolicyFilter["NOT_ENDED"] = 0] = "NOT_ENDED";
    EnumPolicyFilter[EnumPolicyFilter["NOT_CANCELED_BEFORE_START"] = 1] = "NOT_CANCELED_BEFORE_START";
})(EnumPolicyFilter || (exports.EnumPolicyFilter = EnumPolicyFilter = {}));
//# sourceMappingURL=EnumPolicyFilter.js.map